// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hGDW","content":"styles_content__TJoQq","row":"styles_row__2z0F6","footer":"styles_footer__1eshA","phraseLength":"styles_phraseLength__2ARZ9"};